<script lang="ts">
	import type { Device } from 'src/types/Device';
	import LightEffectsPalette from 'src/components/Sidepanel/DeviceViews/Light/LightEffectsPalette.svelte';

	export let device: Device;
</script>

<LightEffectsPalette {device} />
